<template lang="pug">
.prize-purse(v-if="displayAmount")
  StaticImage.dollar-sign(alt="$" src="Rogue%20Invitational/2023/dollar_icon_lzt0cd.svg" contain)
  h1
    span(v-for="char in displayAmount" :class="{ 'numbers' : char !== ',' && char !== '.' }") {{ char }}
</template>
<script setup lang="ts">
import { computed, ref, onMounted } from 'vue'
import { useRogue } from '@/js/services/Rogue'
import { numberWithCommasSplit } from '@/js/components/events/utils'

const rogue = useRogue()

const props = defineProps({
  eventId: { type: String, default: 'INVITATIONAL_2023' },
})

const amount = ref<number | null>(null)

const displayAmount = computed(() => {
  if (amount.value === null) {
    return ''
  }

  return numberWithCommasSplit(parseFloat(amount.value.toFixed(2)))
})

onMounted(async () => {
  amount.value = (await rogue.fetch<{total: number}>(`/svc_prizepurse/${props.eventId}`)).total
})
</script>
<style lang="scss" scoped>
.prize-purse {
  display: flex;
  justify-content: center;

  h1 {
    display: inline-block;
    margin: 20px 0 0;

    @include tablet() {
      margin: 10px 0 0;
    }

    @include mobile() {
      margin: 10px 0 0;
    }
  }

  .dollar-sign {
    width: 60px;
    margin-right: $size-xxs;
    display: inline-block;

    @include tablet() {
      width: 35px;
    }

    @include mobile() {
      width: 20px;
    }
  }

  span {
    font-size: 110px !important;
    letter-spacing: 6px;
    color: white;

    @include tablet() {
      font-size: 65px !important;
      letter-spacing: 4px;
    }

    @include mobile() {
      font-size: 40px !important;
      letter-spacing: 4px;
    }
  }

  span.numbers {
    font-family: $font-invitational-nums;
  }
}</style>
